document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {


        
        if (window.innerWidth > 990) { // Check screen size is wider than 990px
            var cards = document.querySelectorAll('.card-wrapper');
            
            cards.forEach(function(card) {
                var video = card.querySelector('.card-background-video');
                
                var backgroundImageContainer = card.querySelector('.card__media .media img'); 
        
                card.addEventListener('mouseenter', function() {
                    video.style.visibility = 'visible';
                    video.style.opacity = '1';
                    video.play();
                    if (backgroundImageContainer) { 
                        backgroundImageContainer.classList.add('fade-out'); // Fade out the background image
                    }
                });
        
                card.addEventListener('mouseleave', function() {
                    video.pause();
                    video.currentTime = 0;
                    video.style.visibility = 'hidden';
                    video.style.opacity = '0';
                    if (backgroundImageContainer) {
                        backgroundImageContainer.classList.remove('fade-out'); // Fade in the background image
                    }
                });
            });
        }


        }, 800);
});


